import { MenuSub } from '@/components/menu';
import { MegaMenuSubDropdown } from './components';
const MegaMenuSubAttorney = items => {
  const referralItem = items.find(item => {
    // title is a FormattedMessage?
    if (item?.title?.props?.id) {
      return item.title.props.id === 'REFERRED.REFERRAL';
    }
    return false;
  });
  console.log('[referralItem]', referralItem);

  return <MenuSub className="menu-default py-2.5 lg:w-[225px]">
    {referralItem.children && MegaMenuSubDropdown(referralItem.children)}
  </MenuSub>;
};
export { MegaMenuSubAttorney };